'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _memoize = require('skald/lib/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _addDisplayName2 = require('./_internal/_addDisplayName');

var _addDisplayName3 = _interopRequireDefault(_addDisplayName2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var internal = function internal(Tag, name) {
  var aliased = function aliased(props) {
    return _react2.default.createElement(Tag, props);
  };
  return (0, _addDisplayName3.default)(aliased, name);
}; /**
    * The alias function generates a memoized function which renders a React
    * Pure-Functional component.
    *
    * @module alias
    * @func
    * @since 1.0.0
    * @param {string} Tag
    * @param {string} name
    * @return {func}
    */

var alias = (0, _memoize2.default)(internal);
exports.default = alias;